// extracted by mini-css-extract-plugin
export var numpadContainer = "_j6-1";
export var phoneButton = "_j6-0";